import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { GridRow, Column, MoneyField } from '../../common';
import SectionLabel from './SectionLabel';

const FECSection9 = ({ q9ColA }) => {
  return (
    <Fragment>
      <GridRow style={{ borderTop: '1px solid #919191' }}>
        <Column sm={4}>
          <SectionLabel
            label="9."
            labelLines={[
              (<span>Debts and Obligations Owed <b>TO</b></span>),
              'the Committee (Itemize all on',
              'Schedule C and/or Schedule D)',
            ]}
          />
        </Column>
        <Column sm={4} classNames="entry-row">
          <MoneyField
            disabled
            value={q9ColA || 0}
          />
        </Column>
      </GridRow>
    </Fragment>
  );
};

FECSection9.propTypes = {
  q9ColA: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FECSection9;
